import React from 'react';
import { SubmitEmailStep } from '../../SubmitEmailStep';

export const ConfirmEmailStep = ({ goNext }: { goNext: () => void }) => {
  return <SubmitEmailStep goNext={goNext} />;
};
